import { getCommonConfig } from '../utils/commonConfig';
var MEDIA_STUDIO_BI_SRC = 94;
export function sendBiEvent(biParams) {
    new Image().src = getBiUrl(biParams);
}
export function getBiUrl(opts) {
    var _ = Math.random();
    var commonConfigData = getCommonConfig();
    var brand = (commonConfigData === null || commonConfigData === void 0 ? void 0 : commonConfigData.brand) || 'wix';
    var params = Object.keys(opts)
        .filter(function (key) { return opts[key] !== undefined; })
        .map(function (key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(String(opts[key])));
    })
        .join('&');
    return "//frog.".concat(brand, ".com/media-studio?src=").concat(MEDIA_STUDIO_BI_SRC, "&").concat(params, "&_brandId=").concat(brand, "&_=").concat(_);
}
//# sourceMappingURL=sendBiEvent.js.map